module.exports = __webpack_public_path__ + "assets/galleryBtn.7c41703257fa2f68ba3398d8e8b114d2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/play-screen-ui/galleryBtn.svg
// module id = 187
// module chunks = 0